<div class="home-container">

  <!-- Top accent bar -->
  <div class="top-accent-bar"></div>
  <app-navbar page="home"></app-navbar>

  <!-- Hero Section -->
<section class="hero-section" id="home">
  <img src="assets/images/Hero-Hexa-Spiral.png" alt="" class="hero-bg-pattern">

  <div class="hero-content">
    <div class="hero-text">
      <h1 class="hero-title">
        e-Likita bridges<br />
        <span class="accent">Healthcare<br /></span> delivery gaps.
      </h1>

      <p class="hero-subtitle-text">
        AI-powered clinical decision support, built for frontline healthcare workers.
      </p>

      <div class="hero-cta-group">
        <button mat-flat-button color="primary" class="hero-primary-btn" (click)="onRegisterHospital()">
          <mat-icon>add_business</mat-icon>
          <span>Get Started — Register Your Hospital</span>
        </button>
        <a class="hero-signin-link" (click)="onAccessExistingHospital()">
          Already registered? Sign in →
        </a>
      </div>
    </div>

    <div class="hero-visual">
      <div class="hero-visual-frame">
        <img src="assets/images/hero-image.webp" alt="Telemedicine session" class="hero-visual-img">
      </div>
    </div>
  </div>

  <button mat-button class="scroll-down-btn" (click)="scrollToFeatures()">
    <span>Learn More</span>
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>
</section>

  <!-- Mission / About Section -->
 <section class="about-section" id="about">
  <div class="about-bg-watermark"></div>

  <div class="about-visual about-visual--desktop">
    <div class="about-visual-frame">
      <div class="about-visual-decor-1"></div>
      <div class="about-visual-decor-2"></div>
      <img src="/assets/images/about-image.webp" alt="Doctor consultation" class="about-visual-img">
    </div>
  </div>

  <div class="about-text">
    <h2 class="eyebrow">About Us</h2>
    <h3 class="about-title">Strengthening Healthcare Systems</h3>

    <div class="about-visual about-visual--mobile">
      <div class="about-visual-frame">
        <div class="about-visual-decor-1"></div>
        <div class="about-visual-decor-2"></div>
        <img src="/assets/images/about-image.webp" alt="Doctor consultation" class="about-visual-img">
      </div>
    </div>

    <p class="about-description">
      Built to integrate seamlessly into existing healthcare systems, e-Likita
      strengthens frontline healthcare workers with intuitive digital tools and
      enables real-time collaboration with experts.
    </p>

    <div class="about-quote">
      <img src="/assets/images/drsadiq.jpg" alt="Dr. Muhammad Saddiq" class="quote-avatar-img">
      <div>
        <p class="quote-text">
          "Our goal is to bridge gaps in healthcare delivery, making quality
          healthcare more accessible, efficient, and sustainable"
        </p>
        <p class="quote-author">Dr. Muhammad Saddiq</p>
        <p class="quote-role">Founder</p>
      </div>
    </div>
  </div>
</section>

  <mat-divider></mat-divider>

  <!-- Features Section -->
 <section id="features-section" class="features-section">
  <div class="features-bg-watermark-wrapper">
    <img src="assets/images/Specialties-Section-Hexa-Spiral.png" alt="" class="features-bg-watermark">
  </div>

  <div class="features-text">
    <h2 class="eyebrow">Services</h2>
    <h3 class="section-title">Everything a frontline team needs</h3>
    <p class="section-subtitle">
      From the first patient encounter to specialist follow-up, e-Likita keeps
      frontline workers supported, informed, and connected.
    </p>

    <div class="features-visual features-visual--mobile">
      <img src="assets/images/services-image.webp" alt="Health worker using e-Likita" class="features-visual-img">
    </div>
  </div>

  <div class="features-visual features-visual--desktop">
    <img src="assets/images/services-image.webp" alt="Health worker using e-Likita" class="features-visual-img">
  </div>

    <div class="features-grid">
      <mat-card *ngFor="let feature of features" class="feature-card">
        <mat-card-header>
          <div class="feature-icon-wrapper">
            <mat-icon class="feature-icon">{{ feature.icon }}</mat-icon>
          </div>
        </mat-card-header>
        <mat-card-content>
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p class="feature-description">{{ feature.description }}</p>
        </mat-card-content>
      </mat-card>

      <!-- EVENTS CARD - In Features Grid -->
      <mat-card class="feature-card events-feature-card" routerLink="/events">
        <mat-card-header>
          <div class="feature-icon-wrapper">
            <mat-icon class="feature-icon">event_note</mat-icon>
          </div>
        </mat-card-header>
        <mat-card-content>
          <h3 class="feature-title">Training & Events</h3>
          <p class="feature-description">
            Discover upcoming training sessions, webinars, conferences, and workshops
            designed to sharpen frontline skills and knowledge.
          </p>
        </mat-card-content>
      </mat-card>

      <mat-card class="feature-card events-feature-card" routerLink="/e-learning">
  <mat-card-header>
    <div class="feature-icon-wrapper">
      <mat-icon class="feature-icon">school</mat-icon>
    </div>
  </mat-card-header>
  <mat-card-content>
    <h3 class="feature-title">E-Learning</h3>
    <p class="feature-description">
      Free continuing education courses for health workers from NPHCDA.
    </p>
  </mat-card-content>
</mat-card>
    </div>
  </section>

  <mat-divider></mat-divider>

  <!-- Benefits Section -->
  <section class="benefits-section">
    <div class="section-header">
      <h2 class="eyebrow centered">Why e-Likita</h2>
      <h3 class="section-title">Built for the realities of frontline care</h3>
      <p class="section-subtitle">
        Modern technology, designed around the people doing the work.
      </p>
    </div>

    <div class="benefits-grid">
      <div *ngFor="let benefit of benefits" class="benefit-item">
        <div class="benefit-icon-wrapper">
          <mat-icon class="benefit-icon">{{ benefit.icon }}</mat-icon>
        </div>
        <div class="benefit-content">
          <h3 class="benefit-title">{{ benefit.title }}</h3>
          <p class="benefit-description">{{ benefit.description }}</p>
        </div>
      </div>
    </div>
  </section>

  <mat-divider></mat-divider>

<section class="partners-section">
  <img src="assets/images/Specialties-Section-Hexa-Spiral.png" alt="" class="partners-bg-watermark">

  <div class="partners-text">
    <h2 class="eyebrow centered">Collaborations</h2>
    <h3 class="section-title">Partners & Supporters</h3>
    <p class="section-subtitle">
      e-Likita was built through a collaboration between Dechi Health Trust Fund,
      Africa Health Care Development Trust, and DAALITech, with the support of
      dedicated Microsoft volunteers through the Microsoft Global Hackathon.
    </p>
  </div>

  <div class="partners-list">
    <div *ngFor="let partner of partners" class="partner-item" [class.partner-featured]="partner.featured">
      <div class="partner-icon-wrapper">
        <img [src]="partner.logo" [alt]="partner.name" class="partner-logo-img">
      </div>
      <a [href]="partner.url" target="_blank" rel="noopener" class="partner-name">{{ partner.name }}</a>
      <p class="partner-description">{{ partner.description }}</p>
    </div>
  </div>
</section>

  <mat-divider></mat-divider>

  <!-- Call to Action Section -->
  <section class="cta-section" id="contact">
    <mat-card class="cta-card">
      <mat-card-content>
        <div class="cta-content">
          <div class="cta-text">
            <h2 class="cta-title">Ready to bridge the gap at your facility?</h2>
            <p class="cta-description">
              Join the hospitals and clinics already using e-Likita to put AI-powered
              decision support in the hands of their frontline teams.
            </p>
          </div>

                    <div class="cta-actions">
            <button mat-flat-button color="primary" class="cta-primary-btn" (click)="onRegisterHospital()">
              <mat-icon>add_business</mat-icon>
              <span>Get Started - Register Your Hospital</span>
            </button>

            <button mat-stroked-button class="cta-secondary-btn" (click)="onAccessExistingHospital()">
              <mat-icon>login</mat-icon>
              <span>Sign In to Existing Account</span>
            </button>

            <button mat-stroked-button class="cta-secondary-btn" routerLink="/events">
              <mat-icon>event_note</mat-icon>
              <span>View Training & Events</span>
            </button>
          </div>

          <div class="cta-doctor-note">
            <p>Are you a doctor wanting to offer remote services?</p>
            <a routerLink="/remote-doctor/register" mat-stroked-button color="primary">
              <mat-icon>medical_services</mat-icon>
              <span>Register as Remote Doctor</span>
            </a>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </section>
 <!-- Footer -->
 <app-footer></app-footer>
</div>
